import React, { useState, useEffect, useRef, useMemo } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
import { withStyles } from "@mui/styles";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import { alpha, styled } from '@mui/material/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: '#fff',
    display: "flex",
  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0rem 0rem",
  },
  inputTitle: {
    margin: "0.2rem 0rem 0.05rem 0.5rem",
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    color: "rgba(0, 0, 0, 0.54)",
  },
  select: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0.5rem",
  },
  switch: {
    marginLeft: "0.5rem",
  },
}));


const GreenSwitch = styled(Switch)(({ theme }) => ({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color:  "#91C73C",
    '&:hover': {
      backgroundColor: alpha( "#91C73C", 0.04),
    },
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor:  "#91C73C",
  },
}));

export default function CustomSwitch(props) {
  const { inputTitle, checkedState, handleSwitchChange, name, style } = props;

  const classes = useStyles();

  return (
    <div style={style}>
      <div className={classes.inputTitle}>{inputTitle}</div>{" "}
      <div className={classes.switch}>
        <FormControlLabel
          control={
            <GreenSwitch
            disabled={props.disabled}
              checked={checkedState}
              onChange={() => {
                handleSwitchChange();
              }}
              name={name}
            />
          }
          label=""
        />
      </div>
    </div>
  );
}

CustomSwitch.defaultProps = {
  style: {margin: "1.3rem 0rem 1.3rem 1rem"}
}

CustomSwitch.propTypes = {
  inputTitle: PropTypes.any,
  dateInput: PropTypes.any,
  handleDateInputChange: PropTypes.any,
  style: PropTypes.object,
};
